<template>
    <div>
        <div id="content" class="content animated slideInRight delay-1s">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Exportar Usuários
                                <span class="required_fields"><span class="required">*</span> Campos obrigatórios</span>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <form :action="$store.state.url + 'export/users'" id="export" target="_blank">
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label for="carDateEnd"><span class="required">*</span> Filtrar por
                                                        Departamento</label>
                                                    <select style="display: inline" class="form-control"
                                                        v-model="departments.department_id" name="department_id" required>
                                                        <option value="0" selected>Todos os Departamentos</option>
                                                        <option v-for="department in departments" :key="department.id"
                                                            :value="department.id">{{ department.description }}</option>
                                                    </select>
                                                    <input type="hidden" v-model="this.$store.state.user.id"
                                                        class="form-control" name="uid" id="uid">
                                                </div>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="block text-right">
                                            <a @click="checkForm" class="btn btn-add">
                                                Exportar em Excel <i class="fas fa-file-export"></i>
                                            </a>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import CtkDateTimePicker from 'vue-ctk-date-time-picker';

export default {
    data() {
        return {
            departments: {
                department_id: 0
            },
        }
    },
    methods: {
        checkForm: function () {

            if (this.departments.department_id == '') {
                swal("Erro", "Os dados do formulário não podem ser vazios", "error");
            } else {
                this.extract();
                
            }

        },
        extract(extraction) {

            $("#page_loader").show();
            const self = this;
            const api = self.$store.state.api + "export/users"



            self.$http.post(api, {
                department: self.departments.department_id,
                uid: self.$store.state.user.id
            })
                .then(response => {
                    $("#page_loader").hide();
                    window.open(
                        self.$store.state.url +
                        "downloadExtractByHash/" +
                        response.data,
                        "_blank"
                    );
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                    $("#page_loader").hide();
                });
        },
        getDepartments: function () {
            let self = this;
            let api = self.$store.state.api + "departments?paginated=false";

            self.$http
                .get(api, {
                    params: {
                        orderByAsc: "id"
                    }
                })
                .then(response => {
                    self.departments = response.data.data;
                })
                .catch(error => {

                });
        },
    },
    mounted: function () {
        const self = this;
        self.getDepartments();
    },
    components: {
        CtkDateTimePicker
    }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/Exportation/Users.vue